import { getFromLocalStorage, putToLocalStorage } from "./localStorageService";
import { UpdateAction } from "@/models/socketIo/updateAction";

export const getLocalActionHistory = (matchId: string) =>
  getFromLocalStorage("actionHistory")?.[matchId];

export const addLocalActionHistory = (
  matchId: string,
  updateAction: UpdateAction,
): UpdateAction[] => {
  const actionHistoryData = getFromLocalStorage("actionHistory") || {};
  const existingActionHistory =
    actionHistoryData?.[matchId]?.actionHistory || [];
  const updatedActionHistory = [
    ...existingActionHistory.filter(
      (action) => action.orderRank !== updateAction.orderRank,
    ),
    updateAction,
  ];
  putToLocalStorage("actionHistory", {
    ...actionHistoryData,
    [matchId]: { matchId, actionHistory: updatedActionHistory },
  });
  return updatedActionHistory;
};

export const updateLocalActionHistory = (
  matchId: string,
  actionHistory: UpdateAction[],
): UpdateAction[] => {
  const actionHistoryData = getFromLocalStorage("actionHistory") || {};
  putToLocalStorage("actionHistory", {
    ...actionHistoryData,
    [matchId]: { matchId, actionHistory },
  });
  return actionHistory;
};
